var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.73 0.890481L18.29 5.00048C19.3567 5.77576 19.9914 7.01185 20 8.33048V15.7705C19.94 18.1637 17.9534 20.0564 15.56 20.0005H4.44C2.04665 20.0564 0.0600245 18.1637 0 15.7705V8.34048C0.00610336 7.01612 0.645442 5.77462 1.72 5.00048L7.27 0.890481C8.89636 -0.296827 11.1036 -0.296827 12.73 0.890481ZM15.56 18.5005C17.1251 18.5568 18.4404 17.3354 18.5 15.7705V8.33048C18.4948 7.48583 18.0812 6.6959 17.39 6.21048L11.84 2.10048C10.7439 1.30006 9.25609 1.30006 8.16 2.10048L2.61 6.20048C1.91817 6.69448 1.50534 7.4904 1.5 8.34048V15.7705C1.56502 17.333 2.87698 18.5512 4.44 18.5005H15.56Z",
    fill: "#E94D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.7505H5.5C5.08579 13.7505 4.75 14.0863 4.75 14.5005C4.75 14.9147 5.08579 15.2505 5.5 15.2505H14.5C14.9142 15.2505 15.25 14.9147 15.25 14.5005C15.25 14.0863 14.9142 13.7505 14.5 13.7505Z",
    fill: "#E94D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRed);
export default __webpack_public_path__ + "static/media/Home-red.a8d8fdffd12283d1cf0fba8a2c253f64.svg";
export { ForwardRef as ReactComponent };